import {useContext} from 'react'
import {ProjectsListPageContext} from '../../context'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {ProjectArchiveConfirmationModalTypes} from '../../interfaces'

const ProjectArchiveConfirmationModal = ({
  projectDetails,
  show,
  onClose,
}: ProjectArchiveConfirmationModalTypes) => {
  const {updateProjectDetails, isOperationLoading, isLoading} = useContext(ProjectsListPageContext)

  const handleArchiveProject = () => {
    if (projectDetails) {
      const updatedDetails = {
        isArchived: !projectDetails?.isArchived,
      }
      updateProjectDetails(updatedDetails, projectDetails.id)
    }
  }

  return (
    <ConfirmationModal
      show={show}
      onClose={onClose}
      body={
        <p>
          Do you really want to {projectDetails?.isArchived ? 'unarchive' : 'archive'} '
          <strong>{projectDetails?.name}</strong>' project?
        </p>
      }
      onAction={handleArchiveProject}
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      actionBtnClass={projectDetails?.isArchived ? 'btn-primary' : 'btn-danger'}
    />
  )
}

export default ProjectArchiveConfirmationModal
